import styled from 'styled-components';
import { AsideEntityDetails, VideoPosterEntityDetails, EntityInfo } from 'app/components/Entity';

export const AsideMovieDetails = styled(AsideEntityDetails)`
  .b-trailer {
    padding-top: 56.3%;
    position: relative;
    font-size: 0;
  }

  .b-trailer__video {
    width: 100%;
   }
  
  .b-trailer__poster {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    transition: opacity .2s ease-out;

    &::before {
      content: '';
      width: inherit;
      height: inherit;
      position: absolute;
      background-color: ${({ theme }) => theme.color.rgbaBlack('.4')};
      transition: background-color .2s ease-out;
    }
    
    &:hover {
      .svg-play {
        fill: ${({ theme }) => theme.color.rgbaWhite('1')};
      }
      
      &::before {
        background-color: ${({ theme }) => theme.color.rgbaBlack('.5')};
      }
    }
  }
  
  .b-trailer__btn-play {
    width: 56px;
    height: 56px;
    margin: auto;
    position: absolute;
    top: 0
    left: 0;
    right: 0;
    bottom: 0;

    .svg-play {
      width: inherit;
      height: inherit;
      fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
      transition: fill .2s ease-out;
    }
  }
  
  .b-trailer__poster-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .b-trailer__poster._playing {
    opacity: 0;
    pointer-events: none;
  }
  .b-trailer__switcher {
    text-align: center;
  }

  .b-trailer__switcher-btn {
    width: 16px;
    height: 16px;
    padding: 4px;
    &::before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.color.borderLight};
      transition: background-color 0.2s ease-out;
    }
  }

  .b-trailer__switcher-btn:hover,
  .b-trailer__switcher-btn._active {
    &::before {
      background-color: ${({ theme }) => theme.color.accent};
    }
  }
  .b-entity-info__carousel{
    display: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    .b-trailer {
      display: none;
    }
    .s-entity-details__aside-inner{
      margin-top: 290px;
    }
    .b-entity-info__carousel{
      display: block;
      margin-bottom: 10px;
    }
    .b-entity-info__carousel .react-multi-carousel-list{
      margin: 0;
    }
    .b-entity-info__carousel .b-carousel__wrapper{
      top: 0;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    .s-entity-details__aside-inner{
      margin-top: 230px;
    }
  }
`;
export const PosterMovieDetails = styled(VideoPosterEntityDetails)`
  .b-trailer {
    /* padding-top: 25%; */
    position: relative;
    font-size: 0;
  }

  .b-trailer__video {
    width: 100%;
  }

  .b-trailer__poster + .b-title-with-poster > .mobile-view-poster {
    bottom: 0 !important;
  }
  .b-trailer__poster {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.2s ease-out;

    &::before {
      content: '';
      width: inherit;
      height: inherit;
      position: absolute;
      background-color: ;
      background: linear-gradient(
        to right,
        ${({ theme }) => theme.color.rgbaBlack('.7')},
        ${({ theme }) => theme.color.rgbaBlack('.4')}
      );
      transition: background-color 0.2s ease-out;
    }

    &:hover {
      .svg-play {
        fill: ${({ theme }) => theme.color.rgbaWhite('1')};
      }

      &::before {
        background-color: ${({ theme }) => theme.color.rgbaBlack('.5')};
      }
    }
  }

  .b-trailer__btn-play {
    width: 56px;
    height: 56px;
    margin: auto;
    position: absolute;
    bottom: 10px;
    right: 10px;
    z-index:99;
    .svg-play {
      width: inherit;
      height: inherit;
      fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
      transition: fill 0.2s ease-out;
    }
  }

  .b-trailer__poster-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .b-trailer__poster._playing {
    opacity: 0;
    pointer-events: none;
  }
  .b-trailer__switcher {
    text-align: center;
  }

  .b-trailer__switcher-btn {
    width: 16px;
    height: 16px;
    padding: 4px;
    &::before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.color.borderLight};
      transition: background-color 0.2s ease-out;
    }
  }

  .b-trailer__switcher-btn:hover,
  .b-trailer__switcher-btn._active {
    &::before {
      background-color: ${({ theme }) => theme.color.accent};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xs.width}) {
    .b-trailer__switcher {
      transform: translate(-50%, -100%);
      position: absolute;
      left: 50%;
    }

    .b-trailer__btn-play {
      width: 50px;
      height: 46px;
      .svg-play {
        width: inherit;
        height: inherit;
        fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
        transition: fill 0.2s ease-out;
      }
    }
  }
  @media screen and (max-width: 320px) {
    .b-trailer__btn-play {
      width: 42px;
      height: 40px;
      position: absolute;
      bottom: 10px;
      right: 6px;
      .svg-play {
        width: inherit;
        height: inherit;
        fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
        transition: fill 0.2s ease-out;
      }
    }
  }
`;

export const MovieDescription = styled.div.attrs({
  className: 'b-movie-description'
})`
  text-align: center;

  & + ${EntityInfo} {
    margin-top: 20px;
  }

  .b-movie-description__text {
    position: relative;
    text-align: left;
    line-height: 1.5;
    backface-visibility: hidden;
    white-space: pre-line;
    &._short::before {
      content: '';
      width: 100%;
      height: 2.7em;
      position: absolute;
      bottom: -8px;
      background-image: linear-gradient(to top, rgba(36, 36, 36, 0.95) 10%, rgba(36, 36, 36, 0.3));
    }
  }

  .b-movie-description__text + .b-movie-description__text {
    margin-top: ${({ theme }) => theme.indent.s};
  }

  .b-movie-description__btn {
    margin-top: 8px;
  }
`;

export const TitleDate = styled.p`
  padding: ${({ theme }) => `${theme.indent.s} 0`};
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.71;
  letter-spacing: 1.5px;
  text-align: center;
  color: ${({ theme }) => theme.color.labelColor};
`;
